import "../../styles/studio/visualization/updateVisualizationButtons.css";
import SuccessToast from "../common/SuccessToast";
import ErrorToast from "../common/ErrorToast";

const UpdateVisualizationButtons = ({
  error,
  message,
  isLoading,
  updateHandler,
  updateAndPublishHandler,
}) => {
  return (
    <div className="update-visualization-button-container">
      {error && <ErrorToast error={error} />}{" "}
      {message && <SuccessToast message={message} />}
      <div className="update-visualization-actions">
        <button
          type="button"
          className="btn secondary"
          onClick={updateHandler}
          disabled={isLoading}
        >
          Save
        </button>

        <button
          type="button"
          className="btn primary"
          onClick={updateAndPublishHandler}
          disabled={isLoading}
        >
          Update & Publish
        </button>
      </div>
    </div>
  );
};

export default UpdateVisualizationButtons;
